import { DANGER_COLOR, INFO_COLOR, MAIN_COLOR, TEXT_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const TabContainer = styled.div`
	position: relative;
`;

export const TabCounter = styled.div<{ $left?: string }>`
	position: absolute;
	top: 0px;
	left: ${props => props.$left || '105px'};
`;

export const MarginBottom = styled.div`
	top: 0;
	z-index: 1;
	padding: 8px;
	border-radius: 24px;
	background: #fff;
	margin: 0 auto;
	width: fit-content;
	margin-bottom: 8px;
`;

export const GuestsTitle = styled.div<{ $variant: 'main' | 'danger', fontSize?: number }>`
	width: max-content;
	margin: 0 auto;
	border-radius: calc(1px / 0);
  padding: 4px 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: ${props => `${props.fontSize}px` || '16px'};
	position: sticky;
	top: 0px;
	z-index: 1;
	background: ${props => props.$variant === 'main' ? MAIN_COLOR : DANGER_COLOR};
  margin-bottom: 12px;
  line-height: 1.2;
`;

export const GuestsTime = styled.div<{ $variant: 'main' | 'danger' }>`
	width: fit-content;
	margin: 0 auto;
	padding: 2.5px 8px;
	border-radius: calc(1px / 0);
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${TEXT_COLOR};
	font-size: 14px;
	margin-bottom: -11px;
	z-index: 1;
	position: sticky;
	top: 28px;
	background: ${INFO_COLOR};
  line-height: 1.2;
`;

export const GuestsList = styled.div<{ref?: any}>`
	overflow-y: auto;
	overflow-x: hidden;
	padding-bottom: 32px;
  @media screen and (min-width: 767px) {
    padding-right: 12px;
  }
  @media (max-width:767px){
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const RightIcon = styled.div`
	position: absolute;
	right: 0px;
`;